<script setup lang="ts">
import { useNoticeStore } from '@/stores/notice'

const notice = useNoticeStore()
</script>

<template>
  <div class="toast-region" aria-live="polite" aria-label="通知">
    <button v-for="item in notice.notices" :key="item.id" class="toast" :class="`toast--${item.tone}`" type="button" @click="notice.dismiss(item.id)">
      {{ item.message }}
    </button>
  </div>
</template>
